import script from "./PaperPlaneFly.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperPlaneFly.vue?vue&type=script&setup=true&lang=js"

import "./PaperPlaneFly.vue?vue&type=style&index=0&id=43e7ec30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e7ec30"]])

export default __exports__